/**
* @Author: zachalam
* @Date:   2017-03-19T19:05:02-07:00
* @Email:  zach@reflexmedia.com
* @Last modified by:   Daniel
* @Last modified time: 2017-03-27T16:25:55-07:00
*/



import React, { Component } from 'react';

import Container from '../../blocks/Container';
import Button from '../../blocks/Button';
import InputGroup from '../../blocks/InputGroup';
import Panel from '../../common/Panel';
import Header from '../../blocks/Header';
import Headline from '../../common/Headline';
import LongText from '../../common/LongText';
import Checkbox from '../../common/Checkbox';
import Select from '../../common/Select';


class Report extends Component {

  constructor(props) {
    super(props);

    this.state = {
      reason_type: 'inappr_content',
      message: '',
      account: this.props.extprofile.username
    }
    this.handleReason = this.handleReason.bind(this);
    this.handleMsg = this.handleMsg.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleReason(e) { this.setState({reason_type: e.target.value}); }
  handleMsg(e) { this.setState({message: e.target.value}); }
  handleSubmit(e) { e.preventDefault(); this.props.submit(this.state); }

  render() {

      let allowSubmit = Boolean(this.state.message);
      let { extprofile } = this.props;

      return (
        <Container screenTop width='thin'>
          <Panel withHeader>
            <form onSubmit={this.handleSubmit}>
            <Header>
              <Headline>Report {extprofile.username}</Headline>
            </Header>
          <p className="pageHeader-description">
            We review every reported case individually and will take the appropriate action if the reported abuse if found to be true. Please only report real abuses. If you report too many users who are not in fact abusing the system, your account may be suspended without warning. Thank you for helping us make this website better.
          </p>
          <InputGroup vertical inputLabel='Reason for reporting' >
            <Select onChange={this.handleReason} value={this.state.reason_type}>
              <option value='inappr_content'>Inappropriate content in their profile</option>
              <option value='inappr_photo'>Inappropriate photo</option>
              <option value='inappr_messages'>Inappropriate messages</option>
              <option value='spammer'>Spammer</option>
              <option value='scammer'>Scammer</option>
              <option value='solicitation'>Solicitation</option>
              <option value='suspected_escort'>Suspected Escort</option>
              <option value='suspected_underage'>Suspected Underage</option>
            </Select>
          </InputGroup>
          <InputGroup vertical inputLabel='Description'>
            <LongText onChange={this.handleMsg} value={this.state.message} />
          </InputGroup>
          <Button variant={!this.allowsubmit ? 'primary' : 'simple'} disabled={!allowSubmit}>Report {extprofile.username}</Button>
          </form>
        </Panel>
        </Container>
      );



  }
}



export default Report;



// WEBPACK FOOTER //
// ./src/components/pages/Settings/Report.jsx